import { IconsTypesProps } from '../../types';

export const WetWellScadaIcon = ({ width = 47, height = 113 }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 47 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="46.81" height="112.619" fill="white" />
    <rect
      x="0.137677"
      y="0.137677"
      width="46.5347"
      height="112.344"
      stroke="#566369"
      strokeOpacity="0.4"
      strokeWidth="0.275353"
    />
    <rect x="2.08008" y="6.33301" width="42.4411" height="102.982" fill="#F4F4F7" />
    <path
      d="M2.08008 61.6787C16.0953 61.6786 32.8748 61.6789 44.5212 61.6787C44.5212 63.6637 44.5212 109.315 44.5212 109.315H2.08008C2.08008 109.315 2.08008 63.6636 2.08008 61.6787Z"
      fill="#2486FD"
      fillOpacity="0.2"
    />
    <path
      d="M19.223 60.1953V57.2568H18.523V56.8091C18.7473 56.8091 18.9282 56.7883 19.0657 56.7467C19.2049 56.7033 19.309 56.6418 19.3777 56.5622C19.4464 56.4808 19.4871 56.384 19.4998 56.2719H20.0262V60.1953H19.223ZM21.5442 60.1953V57.2568H20.8441V56.8091C21.0684 56.8091 21.2493 56.7883 21.3868 56.7467C21.5261 56.7033 21.6301 56.6418 21.6988 56.5622C21.7676 56.4808 21.8083 56.384 21.8209 56.2719H22.3473V60.1953H21.5442ZM24.81 60.1953V57.9406H24.2918V57.3898H24.81V56.9855C24.81 56.7594 24.8769 56.5839 25.0108 56.4591C25.1446 56.3343 25.3328 56.2719 25.5751 56.2719H26.2182L26.2236 56.7983H25.8519C25.7524 56.7983 25.6837 56.8236 25.6457 56.8742C25.6077 56.9231 25.5887 57.0045 25.5887 57.1184V57.3898H26.1965V57.9406H25.605V60.1953H24.81ZM27.7933 60.2252C27.5455 60.2252 27.3538 60.1935 27.2181 60.1302C27.0843 60.0669 26.9911 59.9782 26.9387 59.8643C26.888 59.7503 26.8627 59.6183 26.8627 59.4682V57.9406H26.4069V57.3898H26.8871L27.0879 56.5432H27.6523V57.3871H28.2763V57.9406H27.6523L27.6577 59.4356C27.6577 59.5043 27.6658 59.5559 27.6821 59.5902C27.7002 59.6228 27.7273 59.6445 27.7635 59.6554C27.8015 59.6644 27.8494 59.6689 27.9073 59.6689H28.2845V60.1573C28.2465 60.1736 28.1895 60.189 28.1135 60.2035C28.0375 60.2179 27.9308 60.2252 27.7933 60.2252Z"
      fill="#3B3B3B"
    />
    <line
      x1="2.5127"
      y1="61.5207"
      x2="44.2974"
      y2="61.5207"
      stroke="#2486FD"
      strokeWidth="0.542658"
    />
  </svg>
);
